import { render } from "./ThemedButton.vue?vue&type=template&id=70f55403"
import script from "./ThemedButton.vue?vue&type=script&lang=js"
export * from "./ThemedButton.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__